export default "__VITE_ASSET__DXLhA3n1__"